import { add, download, transfer } from "@/common/components/icons/svg-icons";
import { IMenuCard } from "./subs/menucard";

export const menuCard = (addFund: () => void): IMenuCard[] => [
  {
    color: "white",
    icon: add,
    description: "Add Fund",
    action: addFund,
    title: "Deposit Money",
  },
  {
    color: "white",
    icon: download,
    description: "Request",
    action: () => {},
    title: "Request Payment",
  },
  {
    color: "white",
    icon: transfer,
    description: "Transfer Fund",
    action: () => {},
    title: "Send Money",
  },
];

export const transactionTableHeaders = [
  "Date",
  "Transaction Type",
  "Amount",
  "Status",
];

export const transactionTableKeys = [
  "date",
  "transaction_type",
  "amount",
  "status",
];

export const getTransactionData = () => {
  const data = new Array(10).fill(null).map((_, index) => ({
    id: index + 1,
    date: { value: `10-12-${index + 2}`, type: "string" },
    transaction_type: {
      value: index % 2 ? "deposit" : index % 3 ? "withdrawal" : "payment",
      type: "string",
    },
    amount: { value: `${(index + 1) * 5000}`, type: "string" },
    status: {
      value:
        index % 2 ? (
          <span className="text-green-500">Completed</span>
        ) : index % 3 ? (
          <span className="text-yellow-600 rounded-md">Pending</span>
        ) : (
          <span className="text-red-500">Failed</span>
        ),
      type: "string",
    },
  }));
  return data;
};

export const addFundInput = [
  {
    inputType: "radio",
    name: "transaction_type",
    fullWidth: false,
    rules: {},
    options: [{}],
  },
];

export const bankDetailsInput = [
  {
    name: "card_number",
    placeholder: "8123280394",
    prompt: "Card Number",
    inputType: "text",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 10,
        errorMessage: "Account number should be at least 10",
      },
    },
  },
  {
    name: "expiry_date",
    prompt: "Expiry Date",
    placeholder: "01/24",
    inputType: "text",
    fullWidth: false,
  },
  {
    name: "cvv",
    prompt: "CVV",
    placeholder: "CVV",
    inputType: "text",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 3,
        errorMessage: "CVV number should be at least 3",
      },
    },
  },
  {
    name: "amount",
    prompt: "Amount",
    placeholder: "Amount",
    inputType: "text",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 1,
        errorMessage: "least amount permissible is 10",
      },
    },
  },
];

export const cardDetailsInput = [
  {
    name: "amount",
    placeholder: "",
    prompt: "Amount",
    inputType: "text",
    fullWidth: true,
    rules: {
      minLength: {
        expectedValue: 2,
        errorMessage: "Account number should be at least 10",
      },
    },
  },
];
